import styles from './TenantSelector.module.css';
import { TenantSelectorBody } from './TenantSelectorBody';
import { TenantSyncModeSelector } from './TenantSyncModeSelector';
import type { TenantSelectorProps, TenantSyncMode } from './types';

export function TenantSelector({
  selection,
  onChange,
  allTenantsSelectionDescription,
  selectedTenantsSelectionDescription,
  disabled = false,
  tenantRowData,
  listOnly = false,
  isLoading = false,
  includeDraftOption = false,
  draftSelectionDescription,
}: TenantSelectorProps) {
  const allCurrentTenantIds = Object.keys(tenantRowData);
  const { selectionType, selectedTenantIds, excludedTenantIds } = selection;

  const isDraft = includeDraftOption && selectionType === 'selected' && selectedTenantIds.length === 0;
  let mode: TenantSyncMode = 'selected';
  if (selectionType === 'all') {
    mode = 'all';
  } else if (isDraft) {
    mode = 'draft';
  }

  const handleModeChange = (nextMode: TenantSyncMode) => {
    if (disabled) {
      return;
    }
    if (nextMode === 'all') {
      onChange({ selectionType: 'all', selectedTenantIds, excludedTenantIds: [] });
    } else if (nextMode === 'draft') {
      onChange({ selectionType: 'selected', selectedTenantIds: [], excludedTenantIds: [] });
    } else if (mode === 'all') {
      const excludedIdSet = new Set(excludedTenantIds);
      const includedTenantIds = allCurrentTenantIds.filter(id => !excludedIdSet.has(id));
      onChange({
        selectionType: 'selected',
        selectedTenantIds: includedTenantIds,
        excludedTenantIds: [],
      });
    } else {
      const newIds = selectedTenantIds.length > 0 ? selectedTenantIds : allCurrentTenantIds;
      onChange({ selectionType: 'selected', selectedTenantIds: newIds, excludedTenantIds: [] });
    }
  };

  return (
    <section className={listOnly ? undefined : styles.section}>
      {!listOnly && (
        <TenantSyncModeSelector
          mode={mode}
          onModeChange={handleModeChange}
          excludedTenantCount={selectionType === 'all' ? excludedTenantIds.length : 0}
          includeDraftOption={includeDraftOption}
          allTenantsSelectionDescription={allTenantsSelectionDescription}
          selectedTenantsSelectionDescription={selectedTenantsSelectionDescription}
          draftSelectionDescription={draftSelectionDescription}
          disabled={disabled}
        />
      )}

      <div className={styles.body}>
        <TenantSelectorBody
          selection={selection}
          tenantRowData={tenantRowData}
          disabled={disabled}
          onChange={onChange}
          hideToolbar={listOnly}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
}
